import AbstractStore from 'core/abstracts/AbstractStore';
import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';

class UserActionsStore extends AbstractStore {

    constructor() {

        const CHANGE_EVENT = 'USER_CHANGE_EVENT';
        const NAME = 'USER_STORE';

        super(NAME, CHANGE_EVENT);

        this._initStore();

        // Registers action handler with the Dispatcher.
        Dispatcher.register(this._registerToActions.bind(this));
    }

    _initStore() {
        this.loading = true;
        this.users = [];
        this.currentUser = null;
        this.count = 0;
        this.userActionsData = null;
        this.useActionGraphData = [];
        this.loadingUserActions = false;
        this.actionsNames = [];
    }

    isLoading() {
        return this.loading;
    }

    isLoadingUserActions() {
        return this.loadingUserActions;
    }

    getUsers() {
        return this.users;
    }

    getUserActionsData() {
        return this.userActionsData;
    }

    getUserActionsParams() {
        return this.userActionsParams;
    }

    getUserActionsGraphData() {
        return this.userActionsGraphData;
    }

    getActionsNames() {
        return this.actionsNames;
    }

    setUsers(users) {
        this.users = users;
    }

    setUserActionsData(data) {
        this.userActionsData = data;
    }

    setUserActionsGraph(data) {
        this.userActionsGraphData = data;
    }

    setActionsNames(data) {
        this.actionsNames = data;
    }

    deleteUser(id) {
        this.users = this.users.filter(a => a.id !== id);
    }

    addUser(user) {
        this.users.push(user);
        this.users = this.users.sort((a,b) => a.login > b.login ? 1 : b.login > a.login ? -1 : 0).slice(0);
    }

    updateUser(options) {
        this.users = this.users.map(s => {
            if (s.id === options.id) {
                for (const prop in options) {
                    s[prop] = options[prop];
                }
            }

            return s;
        }).sort((a,b) => a.login > b.login ? 1 : b.login > a.login ? -1 : 0);
    }

    // Switches over the action's type when an action is dispatched.
    _registerToActions(action) {
        switch (action.actionType) {
        case Constants.LOGOUT:
            this._initStore();
            this._emitChange();
            break;
        case Constants.USERS_GET_START:
            this.loading = true;
            this._emitChange();
            break;
        case Constants.USERS_GET_END:
            this.loading = false;
            this.setUsers(action.value);
            this._emitChange();
            break;
        case Constants.USER_ADDED:
            this.addUser(action.value);
            this._emitChange();
            break;
        case Constants.USER_UPDATED:
            this.updateUser(action.value);
            this._emitChange();
            break;
        case Constants.USER_DELETED:
            this.deleteUser(action.value.id);
            this._emitChange();
            break;
        case Constants.USER_ACTIONS_GET_START:
            this.loadingUserActions = true;
            this._emitChange();
            break;
        case Constants.USER_ACTIONS_GET_END:
            this.setUserActionsData(action.value);
            this.loadingUserActions = false;
            this._emitChange();
            break;
        case Constants.USER_ACTIONS_GRAPH_GET_START:
            this.loadingUserActions = true;
            this._emitChange();
            break;
        case Constants.USER_ACTIONS_GRAPH_GET_END:
            this.setUserActionsGraph(action.value);
            this.loadingUserActions = false;
            this._emitChange();
            break;
        case Constants.USER_ACTIONS_NAMES_GET:
            this.setActionsNames(action.value);
            this._emitChange();
            break;
        default:
            return false;
        }
    }

}

export default new UserActionsStore();
